import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from "lucide-react";
  

const WhyUs = () => {
  const navigate = useNavigate();
  const handleFreeConsultation = () => navigate('/contact');
  return (
    <>
    <section id="why" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* HEADER */}
        <div className="grid md:grid-cols-2 gap-10 mb-20">
          <div>
            <p className="text-[#d97925] uppercase tracking-widest font-semibold text-sm">
              Why TickBox
            </p>
            <h2 className="text-5xl font-bold tracking-tight mt-4 leading-tight">
              A fundamentally <br /> different model
            </h2>
          </div>

          <div className="text-lg text-zinc-600 leading-relaxed">
            In a market where compliance is treated as a commodity, TickBox
            combines technology, expertise, and genuine accountability in a way
            no traditional consultancy can match.
          </div>
        </div>

        {/* WHY GRID */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {/* CARD 1 */}
          <div className="border border-zinc-200 rounded-3xl p-8 hover:shadow-xl transition">
            <div className="text-4xl mb-5">⚙️</div>
            <h3 className="text-2xl font-semibold mb-4">Technology</h3>
            <p className="text-zinc-600 leading-relaxed">
              We build our own proprietary platforms rather than using generic tools.
              Real-time dashboards, AES encrypted data, and automated filing workflows
              built specifically for Indian statutory compliance.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="border border-zinc-200 rounded-3xl p-8 hover:shadow-xl transition">
            <div className="text-4xl mb-5">🎓</div>
            <h3 className="text-2xl font-semibold mb-4">Expertise</h3>
            <p className="text-zinc-600 leading-relaxed">
              Unparalleled knowledge of statutory laws across 18+ states. We anticipate
              regulatory amendments and act before deadlines — never reactive, always
              ahead of compliance obligations.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="border border-zinc-200 rounded-3xl p-8 hover:shadow-xl transition">
            <div className="text-4xl mb-5">🛡️</div>
            <h3 className="text-2xl font-semibold mb-4">Reliability</h3>
            <p className="text-zinc-600 leading-relaxed">
              Zero-lapse compliance management with proactive alerts, deadline tracking,
              and error-free submissions across every mandate — shielding your business
              from penalties and reputational damage.
            </p>
          </div>
        </div>

        {/* DIFFERENTIATORS */}
        <div className="grid md:grid-cols-2 gap-6">
          {[
            {
              title: "End-to-end coverage:",
              text: "From registrations to litigation — the entire compliance lifecycle."
            },
            {
              title: "Technology-native:",
              text: "We build our own platforms rather than relying on generic tools."
            },
            {
              title: "Multi-state expertise:",
              text: "Deep knowledge across 18+ states including Tamil Nadu, Maharashtra, Karnataka, and Gujarat."
            },
            {
              title: "Proactive approach:",
              text: "We anticipate amendments and act before deadlines — never reactive."
            },
            {
              title: "Client transparency:",
              text: "Real-time dashboards with full visibility into compliance status at all times."
            },
            {
              title: "Dedicated account management:",
              text: "Every client has a named compliance specialist."
            },
            {
              title: "Audit-ready documentation:",
              text: "All records maintained digitally, available on demand."
            },
            {
              title: "Scalable models:",
              text: "Suitable for 10-employee startups to 10,000+ workforce enterprises."
            }
          ].map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-zinc-50 border border-zinc-200 rounded-xl p-5 hover:border-[#d97925]/50 transition"
            >
              <span className="text-[#d97925] text-lg mt-1">✓</span>
              <p className="text-zinc-700 leading-relaxed">
                <span className="font-semibold">{item.title}</span> {item.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
    
  
    {/* Final CTA */}
     <section className="py-28  bg-gradient-to-br from-[#111111] to-[#111111] text-white">
             <div className="max-w-7xl mx-auto px-6 text-center">
               <motion.h2
                 initial={{ opacity: 0, y: 60 }}
                 whileInView={{ opacity: 1, y: 0 }}
                 viewport={{ once: true }}
                 transition={{ duration: 0.9 }}
                 className="text-5xl font-bold tracking-tight mb-8"
               >
                 The Right Partner makes A Difference
               </motion.h2>
     
               <p className="text-2xl mb-12 max-w-3xl mx-auto opacity-90">
                We combine expertise, transparency and a people first approach.
               </p>
     
               <motion.button
                 whileHover={{ scale: 1.05 }}
                 whileTap={{ scale: 0.98 }}
                 onClick={handleFreeConsultation}
                 className="inline-flex items-center gap-4 px-12 py-7 bg-white text-[#d97925] font-bold text-2xl rounded-3xl shadow-2xl hover:bg-emerald-50 transition-colors"
               >
                 Get Started with TickBox
                 <ArrowRight size={32} />
               </motion.button>
             </div>
           </section>
      </>

  );
};

export default WhyUs;